import { CrossClientQueryLogicalQuestionDecomposition } from '../../../models/CrossClient'

export interface CrossClientDefault {
  id: string
  title: string
  description: string
  icon: string
  decomposition: CrossClientQueryLogicalQuestionDecomposition
}

// todo
export const CROSS_CLIENT_DEFAULTS: Record<string, CrossClientDefault[]> = {
  'Wealth Management': [
    {
      id: 'default-query-1',
      title: 'Retirement Readiness Assessment',
      description: 'Identify clients over 50 with retirement savings below the recommended benchmark for their age bracket and income level.',
      icon: 'bi-bank',
      decomposition: {
        explanation: 'Test',
        logicalFormula: 'A OR B',
        atomicClauses: [
          { variable: 'A', description: 'A desc', questionForm: 'A question' },
          { variable: 'B', description: 'B desc', questionForm: 'B question' },
        ],
      },
    },
    {
      id: 'default-query-2',
      title: 'Portfolio Diversification Analysis',
      description: 'Which clients have more than 30% of their investments concentrated in a single sector or asset class?',
      icon: 'bi-cash',
      decomposition: {
        explanation: 'Test',
        logicalFormula: 'A OR B',
        atomicClauses: [
          { variable: 'A', description: 'A desc', questionForm: 'A question' },
          { variable: 'B', description: 'B desc', questionForm: 'B question' },
        ],
      },
    },
    {
      id: 'default-query-3',
      title: 'High-Income Opportunity Identification',
      description: 'List clients with annual income exceeding $250,000 who are not currently utilizing tax-advantaged investment strategies.',
      icon: 'bi-bank',
      decomposition: {
        explanation: 'Test',
        logicalFormula: 'A OR B',
        atomicClauses: [
          { variable: 'A', description: 'A desc', questionForm: 'A question' },
          { variable: 'B', description: 'B desc', questionForm: 'B question' },
        ],
      },
    },
    {
      id: 'default-query-4',
      title: 'Cash Management Optimization',
      description: 'Identify clients holding excess cash reserves (more than 12 months of expenses) that could be better deployed in investment vehicles.',
      icon: 'bi-cash',
      decomposition: {
        explanation: 'Test',
        logicalFormula: 'A OR B',
        atomicClauses: [
          { variable: 'A', description: 'A desc', questionForm: 'A question' },
          { variable: 'B', description: 'B desc', questionForm: 'B question' },
        ],
      },
    },
    {
      id: 'default-query-5',
      title: 'Tax-Loss Harvesting Candidates',
      description: 'Which clients have investment positions currently showing unrealized losses that could be used for tax-loss harvesting before year-end?',
      icon: 'bi-bank',
      decomposition: {
        explanation: 'Test',
        logicalFormula: 'A OR B',
        atomicClauses: [
          { variable: 'A', description: 'A desc', questionForm: 'A question' },
          { variable: 'B', description: 'B desc', questionForm: 'B question' },
        ],
      },
    },
    {
      id: 'default-query-6',
      title: 'Social Security Optimization Candidates',
      description: "Which clients approaching retirement age (62-70) haven't yet received guidance on optimal Social Security claiming strategies?",
      icon: 'bi-cash',
      decomposition: {
        explanation: 'Test',
        logicalFormula: 'A OR B',
        atomicClauses: [
          { variable: 'A', description: 'A desc', questionForm: 'A question' },
          { variable: 'B', description: 'B desc', questionForm: 'B question' },
        ],
      },
    },
  ],
  'Estate Planning': [
    {
      id: 'default-query-7',
      title: 'Estate Planning Gap Detection',
      description: "Show clients with net worth over $2M who don't have an updated estate plan or trust in place within the last 5 years.",
      icon: 'bi-cash  ',
      decomposition: {
        explanation: 'Test',
        logicalFormula: 'A OR B',
        atomicClauses: [
          { variable: 'A', description: 'A desc', questionForm: 'A question' },
          { variable: 'B', description: 'B desc', questionForm: 'B question' },
        ],
      },
    },
    {
      id: 'default-query-8',
      title: 'Mortgage Refinancing Opportunities',
      description: 'List clients with mortgage interest rates at least 1% higher than current market rates who could benefit from refinancing.',
      icon: 'bi-cash',
      decomposition: {
        explanation: 'Test',
        logicalFormula: 'A OR B',
        atomicClauses: [
          { variable: 'A', description: 'A desc', questionForm: 'A question' },
          { variable: 'B', description: 'B desc', questionForm: 'B question' },
        ],
      },
    },
  ],
  'Portfolio Health': [],
  'College Planning': [
    {
      id: 'default-query-9',
      title: 'College Planning Assessment',
      description: "Identify clients with children under 15 who haven't established adequate college savings accounts relative to their income level.",
      icon: 'bi-bank',
      decomposition: {
        explanation: 'Test',
        logicalFormula: 'A OR B',
        atomicClauses: [
          { variable: 'A', description: 'A desc', questionForm: 'A question' },
          { variable: 'B', description: 'B desc', questionForm: 'B question' },
        ],
      },
    },
  ],
}

export const FEATURED_CROSS_CLIENT_DEFAULTS: CrossClientDefault[] = [
  CROSS_CLIENT_DEFAULTS['Wealth Management'][0],
  CROSS_CLIENT_DEFAULTS['Estate Planning'][0],
  CROSS_CLIENT_DEFAULTS['College Planning'][0],
]

export const CROSS_CLIENT_DEFAULT_CATEGORIES = ['Featured', ...Object.keys(CROSS_CLIENT_DEFAULTS)]

export type CrossClientDefaultCategory = (typeof CROSS_CLIENT_DEFAULT_CATEGORIES)[number]

export const CROSS_CLIENT_DEFAULT_ICONS: Record<CrossClientDefaultCategory, string> = {
  Featured: 'bi-star',
  'Wealth Management': 'bi-coin',
  'Estate Planning': 'bi-houses',
  'Portfolio Health': 'bi-bar-chart',
  'College Planning': 'bi-mortarboard',
}
